<template>
  <tr class="profile-table__row">
    <td class="profile-table__cell profile-table__cell-registrations">
    <div class="custom-control custom-checkbox ml-2">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="result.registrationId"
          :value="result.registrationId"
          v-model="selectedResults"
        />
        <label :for="result.registrationId" class="custom-control-label"></label>
      </div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">{{ result.registrationId }}</div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        {{ registrationName }}
      </div>
    </td>

    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">{{ registrationLang }}</div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        {{ resultTraining }}
      </div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item d-flex align-items-center">
        <span v-if="formatDate(result.registrationCreatedAt)" class="mr-1 icon icon-calendar" />
        <span class="">
           {{ formatDate(result.registrationCreatedAt, "DD.MM.YYYY") }}
        </span>
      </div>
    </td>
    <!--<td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item d-flex align-items-center">
        <span v-if="formatDate(registration.sessionStartAt)" class="mr-1 icon icon-calendar" />
        <span class="">
           {{ formatDate(registration.sessionStartAt, "DD.MM.YYYY") }}
        </span>
      </div>
    </td>-->
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        <div class="d-flex">
          <!--<span
            class="badge badge-icon badge-pill mr-1"
            :class="
              courseTypeSlug == 'e-learning'
                ? 'badge-school'
                : courseTypeSlug == 'virtual-class'
                ? 'badge-combined'
                : courseTypeSlug == 'classroom'
                ? 'badge-class'
                : 'badge-combined'
            "
          />-->
          <span
           class="badge badge-icon badge-pill badge-icon_fail"></span>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  name: "ResultRow",
  props: ["result", "index", "isLast"],
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapFields(["user", "establishment"]),
    ...mapFields([
      "trainees.trainees",
      "trainees.selectedTrainees",
      "trainees.filtredTrainee",
      "trainees.isFiltrSelected",
      "trainees.isAllTrainnesSelected",
]),
    registrationName() {
      let firstname = this.$lodash.get(
        this.result,
        "traineeFirstname",
        ""
      );
      let lastname = this.$lodash.get(this.result, "traineeLastname", "");
      return lastname + ' ' + firstname
    },
    registrationLang() {
      let tl = this.$lodash.get(this.result, "courseLanguage", "--");
      if (tl != null) {
        return tl;
      } else return "--";
    },
    registrationStatus() {
      let rs = this.$lodash.get(this.result, "resultLessonStatus", false);
    console.log('registrationStatus', rs)
      if (rs != null) {
        return rs;
      } else return "--";
    },
    resultTraining() {
      let cn = this.$lodash.get(this.result, "courseName", "--");
      if (cn != null) {
        return cn;
      } else return "--";
    },
  },
  mounted() {
    this.selectedResults = [];
  },
   methods: {
    formatDate(date, format = "YYYY.MM.DD") {
      if (date && this.$moment(date).isValid()) {
        return this.$moment(date).format(format);
      } else return '--' ;
    },
  },
};
</script>

<style></style>
